// extracted by mini-css-extract-plugin
export default {"player":"Holist_player__H7AsY","new":"Holist_new__73QAW"};